import React from 'react';

import SummaryInfo from './SummaryInfo';
import Summary from './Summary';
import EstimatedCost from '../SurveyTarget/EstimatedCost';

const SummaryBox = () => {
  return (
    <div className="ie--card">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <div className="ie--summary--box">
            <Summary />
          </div>
        </div>
        <div className="ie--card--col ie--bg--gray ie--summary--info-col">
          <SummaryInfo />
        </div>
      </div>
      <EstimatedCost />
    </div>
  );
};

export default SummaryBox;
